import React, { Component } from "react";
import { Grid, Col, Row } from "react-bootstrap";

import UserCard from "../../components/Card/UserCard.jsx";
import Button from "../../components/CustomButton/CustomButton.jsx";

import avatar from "../../assets/img/logo_white_transparent.png";
import bgImage from "../../assets/img/card-info.png";

class Contact extends Component {
  render() {
    return (
        <div className="main-content" style={{backgroundImage: "url("+require("../../assets/img/matrix.jpg")+")", backgroundSize: "cover",
            backgroundPosition: "center center"}}>
            {/*<div className="main-content">*/}
        <Grid fluid>
          <Row>
            <UserCard
                bgImage={bgImage}
                avatar={avatar}
                name="Administrator"
                userName="Tattoo Release Online, INC."
                description={
                    <span>
                      Phone: (303) 525-4478
                        <br />
                        <br />
            <a href="mailto:tattooreleaseonline@gmail.com">Click Here To Email Us</a>
          </span>
                }
            />
          </Row>
        </Grid>
      </div>
    );
  }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/views/Dashboard/Contact.jsx